'use client';
import ContentCenter from '@/components/common/content-center';
import dynamic from 'next/dynamic';
import DedicatedHero from '@/components/dedicated-hero';
import CareerServies from '@/components/technologies/career-demand';
import CarrerMoweb from '@/components/common/carrer-moweb';
import CoreValues from '@/components/technologies/core-values';
import CurrentOpening from '@/components/technologies/current-opening';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import BorderEdge from '@/components/common/border-edge';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <DedicatedHero
                className=""
                pageTitle="Join Our Team"
                isDesc={true}
                desc="Moweb Limited is here to give wings to your professional dreams. If you have exceptional talent and skill sets to differentiate from the rest apply to our vacant positions today!"
                alt="hero image"
                title="hero image"
                width={459}
                height={528}
                path={'career'}
                isButton={true}
            />
            <DefaultBreadcrumb parentPage="Technologies" currentPage="Careers" />
            <ContentCenter topTitle="Why Join Moweb?" title="Join the team. Inspire the Work.">
                <>
                    <p>
                        We embrace innovation and adaptability to create solutions through the synergy of technology and strategy.
                        Our collaborative efforts transcend boundaries, welcoming individuals from diverse backgrounds. We are
                        committed to working together with inclusivity, freedom, and responsibility as guiding principles.
                    </p>
                </>
            </ContentCenter>
            <CarrerMoweb />
            <CareerServies />
            <CoreValues />
            <CurrentOpening />
            {/*<TeamTestimonials />*/}
            <BorderEdge color="text-white" bg="bg-blue" />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
